{
    "RangeCombo_Search_Placeholder": "Procurar...",
    "NAME": "RangeComboLanguage"
}